import { baseAxiosInstance } from '../configuration/axiosConfig';
import { ClientResponse } from '../model/ClientResponse';
import vyhladavanieItem from '../model/vyhladavanieItem';

interface Props {
  nazov: string;
  iri: string;
}

export async function getSearchData(
  value: string,
  requestPath: string,
  path: string,
):
  Promise<ClientResponse<Props[]>> {
  const {
    data,
    status: responseCode,
  } = await baseAxiosInstance.get<vyhladavanieItem[]>(requestPath, {
    params: {
      dopyt: value,
      rows: 50,
    },
  });

  const mappedData = data
    .filter(item => item.popis !== undefined)
    .map((item) => ({
      iri: path + item.iri,
      nazov: item.popis,
    }));

  return {
    data: mappedData,
    responseCode,
  };
}
